export default __webpack_public_path__ + "static/media/maintenance.b35217ff.svg";